import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Zap, Menu, X, KeyRound, ShieldCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const LINKS = [
  { label: "Manifesto", href: "/#manifesto", testid: "nav-link-manifesto" },
  { label: "Library", href: "/library", testid: "nav-link-library" },
  { label: "FAQ", href: "/faq", testid: "nav-link-faq" },
  { label: "Donate", href: "/donate", testid: "nav-link-donations" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { unlocked } = useSite();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#07090E]/80 border-b border-[#1E2638]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="w-8 h-8 rounded-md bg-sky-400/10 border border-sky-400/40 flex items-center justify-center group-hover:bg-sky-400/20 transition-colors">
            <Zap className="w-4 h-4 text-sky-400" />
          </span>
          <span className="font-display font-bold text-lg tracking-tight">SoverTech</span>
          <span className="hidden md:inline font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-0.5">
            Research Fund
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              data-testid={l.testid}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-sky-400 transition-colors"
            >
              {l.label}
            </Link>
          ))}
          {unlocked && (
            <span data-testid="nav-supporter-badge" className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-amber-400 border border-amber-400/30 bg-amber-400/10 rounded-full px-3 py-1">
              <ShieldCheck className="w-3 h-3" /> Supporter
            </span>
          )}
          <button
            onClick={() => navigate("/admin")}
            data-testid="nav-link-admin"
            className="flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.2em] text-slate-500 hover:text-slate-200 transition-colors"
          >
            <KeyRound className="w-3.5 h-3.5" /> Console
          </button>
        </nav>

        <button
          className="md:hidden text-slate-300"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1E2638] bg-[#0F131C]/95 backdrop-blur-xl px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300"
            >
              {l.label}
            </Link>
          ))}
          <Link to="/admin" data-testid="nav-link-admin-mobile" onClick={() => setOpen(false)} className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            Console
          </Link>
        </div>
      )}
    </header>
  );
}
